const sessionLogout = () => {
  try {
    sessionStorage.clear();
    localStorage.clear();
    return new Promise((resolve) => {
      window.location.href = "/login";
      resolve();
    });
  } catch (error) {
  }
};

export { sessionLogout };
